__turbopack_context__.v({
  "breakingCard": "BreakingCard-module-scss-module__KVCeFa__breakingCard",
  "link": "BreakingCard-module-scss-module__KVCeFa__link",
  "separator": "BreakingCard-module-scss-module__KVCeFa__separator",
  "title": "BreakingCard-module-scss-module__KVCeFa__title",
  "vignette": "BreakingCard-module-scss-module__KVCeFa__vignette",
});
